export const EMAIL_VARIABLES_URL = 'account/{accountId}/email-variables?type={type}';
export const GET_EMAIL_TEMPLATES_LIST = 'account/{accountId}/email-template/list';
export const CREATE_UPDATE_EMAIL_TEMPLATES = 'account/{accountId}/email-template';
export const GET_MEETING_EMAIL_TEMPLATE_BY_ID = 'account/{accountId}/email-template/{templateId}?eventId={eventId}&meetingId={meetingId}';
export const SEND_EMAIL = 'account/{accountId}/email-template/send';
export const EMAIL_TEMPLATE_BY_ID = 'account/{accountId}/email-template/{templateId}';
